import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { confirmEmailChange } from 'src/features/user/utils';
import { AppDispatch } from 'src/store/store';
import BkSnackBar from '../snackbar/BkSnackBar';
import { Box } from '@mui/material';
import { Typography } from '../new/Typography';

interface SnackbarProps {
  type: 'success' | 'error';
  msg: string;
}

const ProcessEmailReset: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  const [showSnackbarMsg, setShowSnackbarMsg] = useState<SnackbarProps>({
    msg: '',
    type: 'success',
  });

  useEffect(() => {
    if (!token) {
      navigate('/');
      return;
    }

    const handleConfirmEmailChange = async () => {
      try {
        dispatch(confirmEmailChange(token)).then((response) => {
          if (confirmEmailChange.fulfilled.match(response)) {
            setShowSnackbarMsg({
              msg: 'Your email has been successfully updated. Redirecting...',
              type: 'success',
            });
            setTimeout(() => {
              navigate('/settings');
            }, 2000);
          }
          if (confirmEmailChange.rejected.match(response)) {
            setShowSnackbarMsg({
              msg: 'Something went wrong. Redirecting...',
              type: 'error',
            });
            setTimeout(() => {
              navigate('/');
            }, 2000);
          }
        });
      } catch (error) {
        setShowSnackbarMsg({
          msg: 'Something went wrong. Redirecting...',
          type: 'error',
        });
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
    };

    setTimeout(() => {
      handleConfirmEmailChange();
    }, 2000);
  }, [token]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Typography fontSize={28}>Please wait while we update your email...</Typography>
      <BkSnackBar
        open={!!showSnackbarMsg.msg}
        handleCloseSnackbar={() => setShowSnackbarMsg({ type: 'success', msg: '' })}
        snackMessage={showSnackbarMsg.msg}
        severity={showSnackbarMsg.type}
      />
    </Box>
  );
};

export default ProcessEmailReset;
